import { getLocale } from '../i18n';

/**
 * Attach host UI locale so the backend can localize questions.
 * Backend falls back to English when a locale has no question translations yet.
 */
export function withQuestionLocale<T extends Record<string, unknown>>(payload: T): T & { locale: string } {
  return {
    ...payload,
    locale: typeof payload.locale === 'string' ? payload.locale : getLocale(),
  };
}
